import { ApiError } from "@anyseal/api-client";
import { RequestId } from "@anyseal/ui";

/**
 * Shared failure banner for privileged mutations. Silent failure on admin
 * operations (money completion, MFA reset, job retry, ...) is not acceptable:
 * every mutating control must render its error next to the action.
 */
export function MutationError({ mutation, locale }: { mutation: { error: Error | null }; locale: "zh-CN" | "en" }) {
  if (!mutation.error) return null;
  return (
    <div className="admin-form-error" role="alert">
      <strong>{locale === "zh-CN" ? "操作失败" : "Operation failed"}</strong>
      <span>{mutation.error.message}</span>
      {mutation.error instanceof ApiError && mutation.error.requestId ? <RequestId value={mutation.error.requestId} /> : null}
    </div>
  );
}
